export const GET_QUIZ_TAGS = 'GET_QUIZ_TAGS';
export const GET_QUIZ_TAG_BY_ID = 'GET_QUIZ_TAG_BY_ID';
export const UPDATE_QUIZ_TAG = 'UPDATE_QUIZ_TAG';
export const DELETE_QUIZ_TAG = 'DELETE_QUIZ_TAG';
export const CREATE_QUIZ_TAG = 'CREATE_QUIZ_TAG';
